import { useState, useEffect, useCallback } from 'react';

export function useCookieConsent() {
  const [cookieConsent, setCookieConsent] = useState(() => {
    const saved = localStorage.getItem('arbauto_cookie_consent');
    if (saved === 'true') return true;
    if (saved === 'false') return false;
    return null;
  });

  const [legalModal, setLegalModal] = useState(null);

  const loadAnalytics = useCallback(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;
    if (clarityId && !document.getElementById('clarity-script')) {
      const s = document.createElement('script');
      s.id = 'clarity-script';
      s.innerHTML = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${clarityId}");`;
      document.head.appendChild(s);
    }

    const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
    if (posthogKey && !document.getElementById('posthog-script')) {
      const s = document.createElement('script');
      s.id = 'posthog-script';
      s.innerHTML = `!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);posthog.init("${posthogKey}",{api_host:"${process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com'}"});`;
      document.head.appendChild(s);
    }
  }, []);

  useEffect(() => {
    if (cookieConsent === true) loadAnalytics();
  }, [cookieConsent, loadAnalytics]);

  const handleCookieChoice = (accepted) => {
    setCookieConsent(accepted);
    localStorage.setItem('arbauto_cookie_consent', String(accepted));
  };

  return { cookieConsent, handleCookieChoice, legalModal, setLegalModal };
}
